























































import BaseFilter from "@/components/Filter/BaseFilter";
import { DetailFilterParams } from "@/store/email/statistic/types";
import { Component, PropSync, Watch } from "vue-property-decorator";
import { DatePickerWings, FastDateDetailWings, FilterWings, SelectWings, NumberWings, FilterSelectedItemWings } from "wings-ui-components";
import { beginningOfCurrentDay, currentDateEnd, dateFilter } from "@/utils/date-util";
import { Action, Getter, Mutation } from "vuex-class";
import {notifyError, notifySuccess} from '@/utils/notify-helper';
import {getTranslatedParams} from "@/utils/notify-utils";
import { DetailItem } from "@/store/email/statistic/types";

@Component({
  components: {FilterWings, FastDateDetailWings, DatePickerWings, SelectWings, NumberWings, FilterSelectedItemWings},
  filters: {dateFilter}
})
export default class EmailEventsDetailFilter extends BaseFilter<DetailFilterParams> {
  @PropSync("filterClone") propFilterClone!: DetailFilterParams;
  @PropSync("runFilter") propRunFilter!: boolean;

  @Getter("emailStatisticDetailInfo") messageInfo!: DetailItem;
  @Getter("eventTypeList") eventTypeList!: string[];
  @Mutation('setEmailDetailEvents') setStatistic: any

  @Action("getEmailEventsStatisticDetail") actionGetStatistic: any;
  @Action("exportEmailEventsStatisticDetail") actionExport: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): DetailFilterParams {
    return new DetailFilterParams(beginningOfCurrentDay(), currentDateEnd());
  }

  created() {
    // this.filtered()
  }

  // MSG-5603
  @Watch('messageInfo')
  onMessageInfo(val: DetailItem) {
    if (val) {
      if (this.messageInfo?.create_date) {
        this.filter.date_from = this.messageInfo.create_date;
      }
      this.filtered()
    }
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: "Detail events statistics",
        addititionalInfo: getTranslatedParams(this.filter, {
          type: 'eventType'
        })
      }
      const resp = await this.actionGetStatistic({id: this.$route.params.id, filter: this.filter})
      await this.actionLog(this.logObject)
    } catch(error) {
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
      notifyError(error);
    }
  }

  // Override
  async doActionExport() {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Export",
        actionStatus: 'success',
        objectType: "Detail events statistics",
        addititionalInfo: getTranslatedParams(this.filter, {
          type: 'eventType'
        })
      }
      await this.actionExport({id: this.$route.params.id, filter: this.sendFilter});
      await this.actionLog(this.logObject)
      notifySuccess(this.$t('dialog.export').toString());
    } catch(err) {
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
      notifyError(err);
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChange(val: DetailFilterParams) {
    this.propFilterClone = val;
  }

  @Watch('propRunFilter', {immediate: true})
  onRunFilterChange(val: boolean) {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }

}
